import Toast from '../components/pages/utils/Toast';
import { API } from '../constants/Constants';

import Instance from './interceptor';

const getOrganization = async () => {
  try {
    const data = await Instance.post(`${API.ORGANIZATION_DATA}`);

    if (data) {
      return data.data;
    }
  } catch (error) {
    if (error?.name === 'AxiosError') {
      Toast({ message: `${error?.message}`, variant: 'error' });
    } else {
      Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
    }
  }
};

export const getTotalOrganizationNumber = async () => {
  try {
    const data = await Instance.get(`${API.GET_ORGANIZATION_NUMBER}`);

    if (data) {
      return data.data;
    }
  } catch (error) {
    if (error?.name === 'AxiosError') {
      Toast({ message: `${error?.message}`, variant: 'error' });
    } else {
      Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
    }
  }
};

export const getOrganizationNameAndId = async () => {
  try {
    const data = await Instance.get(`${API.GET_ORGANIZATIONS}`);

    if (data) {
      return data?.data?.allOrganization;
    }
  } catch (error) {
    if (error?.name === 'AxiosError') {
      Toast({ message: `${error?.message}`, variant: 'error' });
    } else {
      Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
    }
  }
};

export default getOrganization;
